import ninegrid from "../index.js";
import { ngCellEx } from "./_ngCell.js";

class ngLineChart extends ngCellEx
{
	#owner;
	#cell;
	#canvas;
	#chart;
	#config;
	
	constructor () {
		super();

		this.applyBaseStyle();
	}
	
	connectedCallback() {
		this.#owner = this.getRootNode().host;//this.closest("nine-grid");
		this.#cell = this.closest("th,td");

		this.shadowRoot.innerHTML = `
			<style>
				:host {
					height: 100%;
				    width: 100%;
				    display: flex;
				    overflow: hidden;
				}
	
				div:first-child {
					height: 100%;
				    width: 100%;
				    --display: inline-flex;
				    --align-items: center;
				    --justify-content: center;
				    --overflow: hidden;
				}
	
				canvas:first-child {
					height: 100%;
				    width: 100%;
				    --display: inline-flex;
				    --align-items: center;
				    --justify-content: center;
				    --overflow: hidden;
				}
			</style>
			<canvas class="chart" width="${$(this).width()}" height="${$(this).height() - 4}"></canvas>
		`;
		
		super.connectedCallback();
		
		this.#canvas = this.shadowRoot.querySelector("canvas.chart");
		
		var labels = JSON.parse(this.getAttribute("labels"));
		var datasets = JSON.parse(this.getAttribute("datasets"));
		
		for (var dataset of datasets) {
			dataset.data = new Array(labels.length);
		}

		this.#config = {
			type: 'line',
			data: {
				labels: labels,
				datasets: datasets,
			},
			options: {
				responsive: true,
				maintainAspectRatio: false,
				//onResize: (chart) => { chart.resize(); },
				plugins: {
					title: { display: false, },
					legend: { display: false, },
				},
				scales: {
					x: { display: false, },
					y: { display: false, },
				},
			},
		}
		
		this.#chart = new Chart(this.#canvas, this.#config);
	};

	
	dataRefresh = (v) => {

		var data = this.cell.closest("tr").data;//.get(this.#cell.dataset.row);
		
		for (var dataset of this.#config.data.datasets) {
			
			var v = data[dataset["data-bind"]];

			switch (typeof v) {
			case "string":
				dataset.data = v.split(",");
				break;
			case "object":
				if (Array.isArray(v)) dataset.data = v;
				break;
			}
		}
		$(this.#canvas).height(28);
		
		setTimeout(() => {
			this.#chart.update();
		});
		
		if (!v) this.reset();
	}
}

if (!customElements.get('ng-line-chart')) {
	customElements.define("ng-line-chart", ngLineChart);
}